import React from 'react';
import PropTypes from 'prop-types';
import Title from '../../../common/Title';
import { Dimmer, Loader } from 'semantic-ui-react';
import css from './ServicesPanelPlaceholder.scss';
import { range } from 'lodash';
import ServicesCardPlaceholder from './ServicesCardPlaceholder';

export default class ServicesPanelPlaceholder extends React.Component {

	get items() {
		return range(this.props.numberOfItems).map(index => <ServicesCardPlaceholder key={index} />);
	}

  get title() {
    return this.props.hideTitle ? null : <Title text={this.props.title} lineHeight="24px" />;
  }

	render() {
		return (
			<div>
        {this.title}
				<Dimmer.Dimmable blurring dimmed className={css['dimmer-container']}>
					<Dimmer active inverted><Loader>{this.props.loadingText}</Loader></Dimmer>
					<div className={css['placeholder']}>{this.items}</div>
				</Dimmer.Dimmable>
			</div>
		);
	}
}

ServicesPanelPlaceholder.defaultProps = {
	numberOfItems: 2,
	loadingText: "Loading",
  title: "Your Services"
};

ServicesPanelPlaceholder.propTypes = {
	numberOfItems: PropTypes.number.isRequired,
	loadingText: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  hideTitle: PropTypes.bool
};
